import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { SCIM_CONFIG } from '@elementary/common-ui/constants/queryKeys';
import * as api from '../api';
import { CreateScimRequest } from '../types';

export const useScim = () => {
  const queryClient = useQueryClient();

  const dataQuery = useQuery({
    queryKey: [SCIM_CONFIG],
    queryFn: api.fetchScimConfig,
  });

  const invalidateScimConfig = () => {
    queryClient.invalidateQueries([SCIM_CONFIG]);
  };

  const createMutation = useMutation({
    mutationFn: api.createScimConfig,
    onSuccess: invalidateScimConfig,
  });

  const deleteMutation = useMutation({
    mutationFn: api.deleteScimConfig,
    onSuccess: invalidateScimConfig,
  });

  const recreateMutation = useMutation({
    mutationFn: async (data: CreateScimRequest) => {
      await api.deleteScimConfig();
      return api.createScimConfig(data);
    },
    onSuccess: invalidateScimConfig,
  });

  return {
    data: dataQuery.data,
    isLoading:
      dataQuery.isLoading ||
      createMutation.isLoading ||
      deleteMutation.isLoading ||
      recreateMutation.isLoading,
    error: dataQuery.error,
    create: createMutation.mutateAsync,
    delete: deleteMutation.mutateAsync,
    recreate: recreateMutation.mutateAsync,
  };
};
